export default __webpack_public_path__ + "static/media/FIREBIRD-RESIDENT-GRIEVANCE-Policy.4198c7a4.pdf";